import { fetch } from '@financial-tool/fetch';
import { UserRole, Workspace } from '../../user-session/types/user';

export default function getAccountantClients() {
  return fetch.get<Workspace[]>(`/user/me/workspaces?role=${UserRole.accountant}`);
}
